<template>
    <div v-if="actual.name===null">
        <h4 class="text-muted">A continuación selecciona tu plataforma de pago preferida:</h4>
        <hr>
        <div v-for="(i,ii) in metodos" :key="i.name" class="text-center">
            <div class="row mb-3 d-flex justify-content-center">
                <img :src="j" v-for="(j,jj) in i.lista" :key="jj" class="col-md-2 col-4 p-2 img-fluid animated zoomInLeft"
                     alt="método">
            </div>
            <div class="row mb-3 d-flex justify-content-center">
                <img :src="j" v-for="(j,jj) in i.bancos" :key="jj" class="col-md-2 col-4 p-2 img-fluid animated zoomInRight"
                     alt="bank">
            </div>
            <div class="row m-0 d-flex justify-content-center">
                <div class="col-md-6 col-12">
                    <button class="btn btn-sm px-5 btn-block animated fadeInUp" :class="'btn-'+i.name" type="button"
                            v-on:click="actual=i">
                        <img :src="i.logo" class="p-2 img-btn" :alt="i.name"/>
                    </button>
                </div>
            </div>
            <hr v-if="ii!==metodos.length-1">
        </div>
    </div>
    <component
            v-else
            :is="actual.name"
            :tipo="tipo"
            :pasarela="actual"
            :persona="persona"
            v-on:regresar="actual={name:null}"
            :component="actual.name"/>
</template>
<script>
    import p2p from "./placeToPay"
    import payme from "./payme"
    import {persona} from "../../../../servicios";
    import constantes from "../../../../constantes";
    export default {
        name: "tarjetas",
        components:{
            p2p,
            payme
        },
        data:()=>({
            persona:{},
            actual:{
                name:null
            },
            metodos:[
                {
                    name: 'p2p',
                    dto: 'PLACETOPAY',
                    logo: 'https://static.placetopay.com/placetopay-logo.svg',
                    lista: [
                        require("../../../../assets/images/pagos/visa_logo.png"),
                        require("../../../../assets/images/pagos/mastercard_logo.png"),
                        require("../../../../assets/images/pagos/dinersclub_logo.png"),
                        require("../../../../assets/images/pagos/dicover_logo.png"),
                        require("../../../../assets/images/pagos/amex_logo.png"),
                    ],
                    bancos:[
                        require("../../../../assets/images/pagos/bcopichincha_logo.png"),
                        require("../../../../assets/images/pagos/bcoGuayaquil_logo.png"),
                    ]
                },
                {
                    name: 'payme',
                    dto: 'PAYME',
                    logo: require("../../../../assets/images/pagos/payme.svg"),
                    lista: [
                        require("../../../../assets/images/pagos/visa_logo.png"),
                        require("../../../../assets/images/pagos/mastercard_logo.png"),
                    ],
                    bancos:[
                        require("../../../../assets/images/pagos/bco del austro.png"),
                    ]
                }
            ],
            mostrar:false,
            tipo:constantes.Constantes.enumeraciones.pagosMetodos[0],
        }),
        methods:{
            parametro:function(){
                if(this.$route.query.type){
                    const aux = this.metodos.find(i => i.name === this.$route.query.type);
                    if (aux)
                        this.actual = aux;
                }
            },
            consultaDatos:function(){
                persona.datosPersonales().then(r=>r.data).then(response=>{
                    this.persona=response;
                    this.parametro();
                });
            },
        },
        mounted() {
            this.consultaDatos();
        }
    }
</script>

<style scoped lang="scss">
    $pagos-btn: (p2p #ff6c0c, payme #fa15b8,);

    @each $type in $pagos-btn {
        .btn-#{nth($type, 1)} {
            border-color: nth($type, 2);

            &:hover, :active, :visited {
                background-color: lighten(nth($type, 2), 20%);
                border-color: nth($type, 2);
            }
        }
    }
</style>
